<template>
    <div>
        <Modal
            class="layerModel"
            width="902"
            v-model="currentStatusUser"
            :closable="false"
            :mask-closable="false"
            :footer-hide="true"
        >
            <!-- 上面提示文字 -->
            <div class="tip-header">
                <span>用户{{ titleTable }}</span>
                <span class="iconfont ys-iconguanbi" @click="handleReset('formValidate')"></span>
            </div>
            <!-- form表单 -->
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
                <div class="userBox">
                    <FormItem prop="user_id" style="margin-right: 18px;width: 100%;">
                        <Input
                            class="ys_input_border_bottom"
                            v-model="formValidate.user_id"
                            placeholder="请输入用户登录名"
                            :disabled="titleLayer === '新建' ? false : true"
                        />
                    </FormItem>
                    <FormItem prop="user_cn_name" style="width: 100%;">
                        <Input
                            class="ys_input_border_bottom"
                            v-model="formValidate.user_cn_name"
                            placeholder="请输入用户名"
                        />
                    </FormItem>
                </div>
                <div class="userBox">
                    <FormItem prop="phone_no" style="margin-right: 18px;width: 100%;">
                        <Input
                            class="ys_input_border_bottom"
                            v-model="formValidate.phone_no"
                            placeholder="请输入手机号"
                        />
                    </FormItem>
                    <FormItem prop="teller_no" style="width: 100%;">
                        <Input
                            class="ys_input_border_bottom"
                            v-model="formValidate.teller_no"
                            placeholder="请输入员工编号"
                        />
                    </FormItem>
                </div>
                <div class="userBox">
                    <FormItem prop="email_add" style="margin-right: 18px;width: 100%;">
                        <Input
                            class="ys_input_border_bottom"
                            v-model="formValidate.email_add"
                            placeholder="请输入邮箱"
                        />
                    </FormItem>
                    <FormItem prop="ent_no" style="width: 100%;">
                        <Select
                            v-model="formValidate.ent_no"
                            placeholder="请选择所属企业"
                            @on-change="handleEnterpriseChange"
                        >
                            <Option
                                v-for="(item, index) in enterpriseList"
                                :value="item.dept_id"
                                :key="index"
                            >
                                {{ item.dept_cn_name }}
                            </Option>
                        </Select>
                    </FormItem>
                </div>
                <div class="selectBox">
                    <FormItem prop="pwdexp_bk_dates" style="margin-right: 14px;width: 100%;">
                        <p class="titles">密码到期日</p>
                        <DatePicker
                            type="date"
                            v-model="formValidate.pwdexp_bk_dates"
                            :clearable="false"
                            placeholder="请选择密码到期日"
                            :options="optionsDisabled"
                        ></DatePicker>
                    </FormItem>
                    <FormItem prop="user_type" style="margin-right: 14px;width: 100%;">
                        <p class="titles">用户类型</p>
                        <Select v-model="formValidate.user_type" placeholder="请选择用户类型">
                            <Option
                                v-for="(item, index) in enum_list"
                                :value="item.ivalue + ''"
                                :key="index"
                            >
                                {{ item.cname }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem prop="bl_dept_id" style="margin-right: 14px;width: 100%;">
                        <p class="titles">所属部门</p>
                        <Select
                            v-model="formValidate.bl_dept_id"
                            clearable
                            ref="firstDept"
                            placeholder="请选择所属部门"
                            @on-change="handleDeparmentClick"
                            :disabled="disabledStatus"
                        >
                            <Option
                                v-for="(item, index) in deptInfos"
                                :value="item.dept_id"
                                :key="index"
                            >
                                {{ item.dept_full_cname }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem style="width: 100%;">
                        <p class="titles">兼职部门</p>
                        <Select
                            v-model="formValidate.first_dept_id"
                            clearable
                            ref="selectTests"
                            placeholder="请选择兼职部门"
                            @on-change="handleUserPartJobClick"
                            :disabled="disabledStatus"
                        >
                            <Option
                                v-for="(item, index) in deptInfos"
                                :value="item.dept_id"
                                :key="index"
                            >
                                {{ item.dept_full_cname }}
                            </Option>
                        </Select>
                    </FormItem>
                </div>
            </Form>
            <el-table
                v-if="tableData && tableData.length > 0"
                :columns="Columns"
                :tableData="tableData"
                :tableHeight="tableHeight"
                @on-InputNumber-change="onInputNumberChange"
                @on-select-change="onSelectChange"
            ></el-table>
            <!-- 按钮组 -->
            <div class="btn-box">
                <Button
                    class="ys-cancel"
                    @click="handleReset('formValidate')"
                    style="width: 100px; margin-right: 20px"
                >
                    取消
                </Button>
                <Button
                    class="ys-confirm"
                    type="primary"
                    @click="handleSubmit('formValidate')"
                    style="width: 100px;"
                >
                    确认
                </Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import ElTable from '_g/commonComponent/table/elTable.vue';
import Columns from './tableConfig.js';
export default {
    components: {
        'el-table': ElTable,
    },
    props: {
        currentStatusUser: {
            type: Boolean,
            defalut: false,
        },
        titleLayer: {
            type: String,
            default: '新建',
        },
        editId: {
            type: String,
            default: '',
        },
        selNowEnterId: {
            type: String,
            defalut: '',
        },
    },
    data() {
        return {
            tableData: [], // 数据
            Columns: [], // 表头
            tableHeight: 312,
            titleTable: '', // 表头title
            formValidate: {
                user_id: '', // 用户名
                user_cn_name: '', // 用户中文名
                phone_no: '', // 用户手机号
                teller_no: '', // 员工编号
                email_add: '', // 邮箱
                pwdexp_bk_dates: '2099-12-30', // 密码到期日
                user_type: '1', // 用户类型
                bl_dept_id: '', // 所属部门
                first_dept_id: '', // 兼职部门
                ent_no: '', // 所属企业
                secd_dept_id: 1, // 兼职部门二 --> 写死
                third_dept_id: 2, // 兼职部门三   -->写死
            },
            ruleValidate: {
                user_id: [{ required: true, message: '请输入用户登录名', trigger: 'blur' }],
                user_cn_name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                phone_no: [
                    { required: false, message: '请输入手机号', trigger: 'blur' },
                    {
                        pattern: /^1[3456789]\d{9}$/,
                        message: '手机号码格式不正确',
                        trigger: 'blur',
                    },
                ],
                teller_no: [{ required: false, message: '请输入员工编号', trigger: 'blur' }],
                email_add: [{ required: false, message: '请输入邮箱', trigger: 'blur' }],
                // pwdexp_bk_dates: [
                //   { required: true, type: 'date', message: '请选择密码到期日', trigger: 'change' }
                // ],
                user_type: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
                bl_dept_id: [{ required: true, message: '请选择所属部门', trigger: 'change' }],
                first_dept_id: [{ required: true, message: '请选择兼职部门', trigger: 'change' }],
                ent_no: [{ required: true, message: '请选择所属企业', trigger: 'change' }],
            },
            enum_list: '', // 用户类型
            deptInfos: '', // 所属部门
            roleUser: [], // 用户角色
            enterpriseList: [], // 所属企业
            disabledStatus: true, // 控制所属部门禁用
            optionsDisabled: {
                disabledDate(date) {
                    return date && date.valueOf() < Date.now() - 86400000;
                },
            },
            addDeptId: '',
        };
    },
    methods: {
        ...mapActions([
            'userTypeSearch', // 用户查询
            'listDeptsByNameAction', // 所属部门查询
            'queryExtDprlListByDeptIdAction', // 部门角色查询
            'addUserAction', // 新建保存
            'updateUserAction', // 编辑保存
            'queryUserByUserIdAction', // 编辑回显
            'searchQryDpDeptInfoList', // 查询所属企业
        ]),
        // 表格中的值发生变化
        onInputNumberChange(rowItem, index, value) {
            this.tableData[index]['inputNumberValue'] = value;
            if (this.roleUser.length > 0) {
                // 说明先选的
                for (let i = 0; i < this.roleUser.length; i += 1) {
                    if (this.roleUser[i].dprl_code === rowItem.dprl_code) {
                        this.roleUser[i]['inputNumberValue'] = value;
                    }
                }
            }
        },
        //
        onSelectChange(selection) {
            this.roleUser = selection;
        },
        // 确认
        handleSubmit(name) {
            this.$refs[name].validate(valid => {
                console.log(valid);
                if (valid) {
                    // this.$Message.success('Success!');
                    // this.$emit('on-jurisdiction-click', 1);
                    this.roleUser.length < 1
                        ? this.$Message.error('请您选中部门角色~')
                        : this.roleFunction();
                } else {
                    this.$Message.error('请完善信息！');
                }
            });
        },
        // 取消
        handleReset(name) {
            this.$refs[name].resetFields();
            this.$emit('on-jurisdiction-click');
        },
        // 选择所属部门用户
        handleDeparmentClick(res) {
            if (
                this.formValidate.bl_dept_id &&
                this.formValidate.first_dept_id === this.formValidate.bl_dept_id
            ) {
                this.$refs.firstDept.clearSingleSelect();
                this.$Message.error('所属部门跟兼职不能一样！');
            }
            if (this.formValidate.bl_dept_id) this.queryExtDprlListByDeptIdActions();
        },
        // 选择兼职部门
        handleUserPartJobClick(res) {
            if (
                this.formValidate.first_dept_id &&
                this.formValidate.first_dept_id === this.formValidate.bl_dept_id
            ) {
                this.$refs.selectTests.clearSingleSelect();
                this.$Message.error('所属部门跟兼职不能一样！');
            }
            if (this.formValidate.first_dept_id) this.queryExtDprlListByDeptIdActions();
        },
        // 新建保存以及编辑保存前对部门角色的处理
        roleFunction() {
            let ev = [];
            for (let i = 0; i < this.roleUser.length; i += 1) {
                const obj = {
                    dept_id: this.roleUser[i].dept_id,
                    role_code: this.roleUser[i].role_code || '',
                    dept_role_weigth: this.roleUser[i].inputNumberValue
                        ? this.roleUser[i].inputNumberValue
                        : 1,
                    dprl_code: this.roleUser[i].dprl_code,
                };
                ev.push(obj);
            }
            // console.log(ev);
            this.formValidate['dept_role_list'] = ev;
            // 处理undefined情况
            this.formValidate['first_dept_id'] =
                this.formValidate.first_dept_id === undefined
                    ? ''
                    : this.formValidate.first_dept_id;
            this.formValidate['bl_dept_id'] =
                this.formValidate.bl_dept_id === undefined ? '' : this.formValidate.bl_dept_id;
            // 时间处理成时间戳
            this.formValidate.pwdexp_bk_date = moment(this.formValidate.pwdexp_bk_dates).format(
                'YYYY-MM-DD HH:mm:ss'
            );
            this.titleLayer === '新建' ? this.addUserActions() : this.updateUserActions();
        },
        // 所属企业选中
        handleEnterpriseChange(res) {
            this.tableData = [];
            this.formValidate.bl_dept_id = '';
            this.formValidate.first_dept_id = '';
            this.roleUser = [];
            // 获取所属部门
            this.listDeptsByNameActions(res);
        },
        // 用户查询
        async userTypeSearchs() {
            try {
                const data = await this.userTypeSearch({
                    class_name: 'ys.manufacture.framework.enu.USER_TYPE',
                });
                if (data.request_state) {
                    this.enum_list = data.enum_list;
                }
            } catch (error) {
                this.$Message.error(error);
            }
        },
        // 所属部门查询
        async listDeptsByNameActions(id) {
            try {
                const data = await this.listDeptsByNameAction({ ent_id: id });
                if (data.request_state) {
                    this.deptInfos = data.dpDeptInfoList;
                    this.disabledStatus = false;
                    if (
                        this.titleLayer === '编辑' &&
                        (this.formValidate.bl_dept_id || this.formValidate.first_dept_id)
                    ) {
                        this.queryExtDprlListByDeptIdActions();
                    }
                }
            } catch (error) {
                this.$Message.error(error);
            }
        },
        // 部门角色查询
        async queryExtDprlListByDeptIdActions() {
            try {
                let ev = [];
                if (this.formValidate.bl_dept_id) {
                    ev.push(this.formValidate.bl_dept_id);
                }
                if (this.formValidate.first_dept_id) {
                    ev.push(this.formValidate.first_dept_id);
                }
                const data = await this.queryExtDprlListByDeptIdAction({ dept_arr: ev });
                if (data.request_state) {
                    let list = data.dprl_bean_list || [];
                    if (this.titleLayer === '编辑' && this.roleUser.length > 0) {
                        for (let i = 0; i < this.roleUser.length; i += 1) {
                            for (let p = 0; p < list.length; p += 1) {
                                if (
                                    this.roleUser[i].dprl_code === list[p].dprl_code &&
                                    this.roleUser[i].dept_id === list[p].dept_id
                                ) {
                                    list[p]['_checked'] = true;
                                    list[p]['inputNumberValue'] = this.roleUser[i].inputNumberValue;
                                }
                            }
                        }
                        this.tableData = list;
                    } else {
                        this.tableData = data.dprl_bean_list || [];
                    }
                }
            } catch (error) {
                this.$Message.error(error);
            }
        },
        // 新建保存
        async addUserActions() {
            try {
                const data = await this.addUserAction(this.formValidate);
                this.formValidate.pwdexp_bk_dates = new Date(this.formValidate.pwdexp_bk_date);
                if (data.request_state) {
                    this.$Message.success('保存成功！');
                    this.$emit('on-jurisdiction-click', 1);
                } else {
                    this.formValidate.pwdexp_bk_dates = new Date(this.formValidate.pwdexp_bk_date);
                }
            } catch (error) {
                this.$Message.error(error);
            }
        },
        // 编辑保存
        async updateUserActions() {
            try {
                this.formValidate['user_id'] = this.editId;
                // console.log(this.formValidate);
                const data = await this.updateUserAction(this.formValidate);
                this.formValidate.pwdexp_bk_date = new Date(this.formValidate.pwdexp_bk_dates);
                if (data.request_state) {
                    this.$Message.success('保存成功！');
                    this.$emit('on-jurisdiction-click');
                }
            } catch (error) {
                this.$Message.error(error);
            }
        },
        // 编辑回显
        async queryUserByUserIdActions(id) {
            try {
                const data = await this.queryUserByUserIdAction({ user_id: id });
                if (data.request_state) {
                    this.formValidate = data.user_bean;
                    this.formValidate.user_type = data.user_bean.user_type + '';
                    this.formValidate.pwdexp_bk_dates = data.user_bean.pwdexp_bk_date;
                    if (data.user_bean.dprl_list && data.user_bean.dprl_list.length > 0) {
                        let ot = data.user_bean.dprl_list.forEach(item => {
                            item.user_bk_weight
                                ? (item['inputNumberValue'] = item.user_bk_weight)
                                : (item['inputNumberValue'] = 1);
                        });
                        this.roleUser = data.user_bean.dprl_list;
                    }
                    // 根据所属企业去查询所属部门
                    this.listDeptsByNameActions(data.user_bean.ent_no);
                }
            } catch (error) {
                this.$Message.error(error);
            }
        },
        // 查询所属企业
        async searchQryDpDeptInfoLists() {
            try {
                const data = await this.searchQryDpDeptInfoList({ dept_cn_name: '' });
                if (data.request_state) {
                    this.enterpriseList = data.dpDeptInfoList;
                    // 所属企业赋值
                    if (this.addDeptId && this.titleLayer === '新建') {
                        this.formValidate.ent_no = this.addDeptId;
                        // 获取所属部门
                        this.listDeptsByNameActions(this.formValidate.ent_no);
                    }
                }
            } catch (error) {
                this.$Message(error);
            }
        },
    },
    mounted() {
        this.Columns = Columns;
        this.titleTable = this.titleLayer;
        this.addDeptId = this.selNowEnterId;
        // 获取用户类型
        this.userTypeSearchs();
        // 获取所属企业
        this.searchQryDpDeptInfoLists();
        switch (this.titleLayer) {
            case '新建':
                break;
            case '编辑':
                this.queryUserByUserIdActions(this.editId);
                break;
            default:
                break;
        }
    },
};
</script>
<style lang="less" scoped>
.layerModel {
    .tip-header {
        width: 100%;
        height: 30px;
        line-height: 30px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        margin-bottom: 24px;
        span:nth-of-type(1) {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(179, 195, 226, 1);
        }
        span:nth-of-type(2) {
            font-size: 28px;
        }
        span:nth-of-type(2):hover {
            cursor: pointer;
        }
    }
    .userBox {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
    }
    .selectBox {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        .titles {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(109, 126, 157, 1);
        }
    }
    .btn-box {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-end;
        margin-top: 40px;
    }
}
</style>
